import { render } from "./Logo.vue?vue&type=template&id=1480808e&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=1480808e&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1480808e"]])

export default __exports__